import actions from '../../actionTypes';

export default () => {
  return {
    type: actions.CLEAR_TAGS
  };
};



// WEBPACK FOOTER //
// ./src/reducers/tags/actions/clearTags.js